<template>
<md-card>
    <header-form title="CADASTRAR CARROS" :rota="{name: 'carrosRead'}" tooltip="Lista de Carros" />

    <form @submit.prevent="create">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>MODELO</label>
                        <md-input v-model="dados.nome" type="text"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.placa }">
                        <label>PLACA</label> 
                        <md-input v-model="dados.placa" type="text" > </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.placa">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.placa" class="validErro"> {{ errors.placa[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.limite }">
                        <label>LIMITE</label>
                        <md-input v-model="dados.limite" type="text" v-money> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.limite">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.limite" class="validErro"> {{ errors.limite[0] }}</div>
                </div>
            </div>
            <div class="md-layout">
                <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <md-autocomplete :class="{ 'md-error': errors.empresa_id }" v-model="empresa" :md-options="empresas" @md-changed="autoCompleteEmpresa" @md-opened="autoCompleteEmpresa" @md-selected="getSelectedEmpresa">
                        <label>EMPRESA</label>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.empresa_id">close</md-icon>
                        </slide-y-down-transition>
                    </md-autocomplete>
                    <div v-if="errors.empresa_id" class="validErro"> {{ errors.empresa_id[0] }}</div>
                </div>

                <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <md-field>
                        <label>OBSERVAÇÃO</label>
                        <md-input v-model="dados.observacao" type="text"> </md-input>
                    </md-field>
                </div>
            </div>

        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {},
            errors: {},
            listEmpresas: [],
            empresas: ['X'],
            empresa: '',
        }
    },

    created() {
        this.getLista();
    },

    mixins: [Notify],

    methods: {

        getLista() {
            this.$http.get(this.$urlAPI + 'carros')
                .then(response => {
                    this.listEmpresas = response.data.dados.empresa
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        autoCompleteEmpresa(searchTerm) {
            this.empresas = new Promise(resolve => {
                if (!searchTerm) {
                    resolve(this.listEmpresas.map(x => x.name));
                } else {
                    const term = searchTerm.toLowerCase();
                    this.empresas = this.listEmpresas.filter(({
                        name
                    }) => {
                        return name.toLowerCase().includes(term);
                    }).map(x => x.name);
                    resolve(this.empresas);
                }
            });
        },

        getSelectedEmpresa() {
            let customer = this.empresa
            this.dados.empresa_id = this.listEmpresas.filter(function (e) {
                return e.name === customer
            })[0].id
        },

        create() {
            this.$http.post(this.$urlAPI + 'carros', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'carrosRead'
                        })
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    }
};
</script>
